export default __webpack_public_path__ + "static/media/researchData.fb331c7f.jpg";